import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { isOfflineMode } from '@atlaskit/editor-plugin-connectivity';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import type { AIPlugin } from '../../../aiPluginType';

export const getIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean =>
	editorExperiment('platform_editor_offline_editing_web', true) &&
	isOfflineMode(api?.connectivity?.sharedState?.currentState()?.mode);

export const useIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean => {
	const { isOffline } = useSharedPluginStateWithSelector(
		api,
		['connectivity'],
		({ connectivityState }) => ({
			isOffline:
				editorExperiment('platform_editor_offline_editing_web', true) &&
				isOfflineMode(connectivityState?.mode),
		}),
	);

	return isOffline;
};
